import React from "react";
import { Group, Circle, Image as KonvaImage } from "react-konva";
import useImage from "use-image";
import { AVATAR_SIZE } from "../../consts";

interface UserAvatarProps {
  url: string;
}

export const UserAvatar = React.memo(({ url }: UserAvatarProps) => {
  const [image] = useImage(url);

  return (
    <Group
      clipFunc={(context: CanvasRenderingContext2D) => {
        context.beginPath();
        context.arc(AVATAR_SIZE / 2, AVATAR_SIZE / 2, AVATAR_SIZE / 2, 0, Math.PI * 2);
        context.closePath();
      }}
    >
      <Circle radius={AVATAR_SIZE / 2} fill="#E0E0E0" x={AVATAR_SIZE / 2} y={AVATAR_SIZE / 2} />

      {image && <KonvaImage image={image} x={0} y={0} width={AVATAR_SIZE} height={AVATAR_SIZE} listening={false} />}
    </Group>
  );
});

UserAvatar.displayName = "UserAvatar";
